import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";
import { Line } from "react-chartjs-2";
import { subDays, subMonths, subYears, format } from "date-fns";
import { svgLogoBase64 } from "../../Constants/config";
import { useSelector, useDispatch } from "react-redux";
import StockMatchSummary from "./stock-match-chart";

const StrategyDetails = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [investmentProductName, setinvestmentProductName] = useState("");
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [stockPrices, setStockprices] = useState([]);
  const [stockpricesUsers, setStockpricesUsers] = useState([]);
  const [matchedStocks, setMatchedStocks] = useState([]);
  const [unmatchedStocks, setUnmatchedStocks] = useState([]);
  const [stockList, setStockList] = useState([]);
  const [caprockStrategyChange, setCaprockStrategyChange] = useState(0);
  const [userStrategyChange, setUserStrategyChange] = useState(0);
  const userId = useSelector((state) => state.user.userId);
  const [combineIndex, setCombineIndex] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("5Y");
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);
  const [rawData, setrawData] = useState([]);
  const DownloadRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [isHiddenTable, setIsHiddenTable] = useState(false); // Initially hidden
  const [selected, setSelected] = useState("Download Report");
  const [period, setPeriod] = useState("five years");
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const [portfolioDataAvailable, setportfolioDataAvailable] = useState(false);
  const [selectedInvestorReport, setselectedInvestorReport] =
    useState("Download Report");
  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Hide the legend
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "#111827",
        titleColor: "#fff",
        borderColor: "#374151",
        borderWidth: 1,
        padding: 12,
        displayColors: false, // Hide colored dots
        callbacks: {
          label: function (tooltipItem) {
            const datasetLabel = tooltipItem.dataset.label || "";
            const value = tooltipItem.formattedValue;
            return `${datasetLabel}: $${value}`;
          },
          labelTextColor: function (context) {
            // Set the text color per dataset
            const index = context.datasetIndex;
            return ["#DC4646", "#3047EC", "#34C046"][index] || "#d1d5db";
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit:
            selectedFilter === "1M" || selectedFilter === "3M"
              ? "day"
              : selectedFilter === "1Y"
              ? "month"
              : "year",
          tooltipFormat:
            selectedFilter === "1M" || selectedFilter === "3M"
              ? "dd MMM yyyy"
              : selectedFilter === "1Y"
              ? "MMM yyyy"
              : "yyyy",
          displayFormats: {
            day: "dd MMM",
            month: "MMM yyyy",
            year: "yyyy",
          },
        },
        ticks: {
          color: "black",
          maxTicksLimit:
            selectedFilter === "1M"
              ? 30
              : selectedFilter === "3M"
              ? 20
              : selectedFilter === "1Y"
              ? 6
              : 5,
          callback: function (value) {
            const date = new Date(value);

            if (selectedFilter === "1M" || selectedFilter === "3M") {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });

              return [day, month];
            } else {
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              }); // e.g., Jan
              const year = date.getFullYear();
              return [month, year];
            }
          },
          font: {
            size: 12,
          },
        },
        grid: {
          drawOnChartArea: false,
          drawTicks: false,
        },
        border: {
          color: "#000",
        },
        afterFit: function (scale) {
          scale.height = 50;
        },
      },

      y: {
        ticks: {
          color: "black", // Set y-axis label color to black
          font: {
            size: 12,
          },
          callback: (value) => `${value.toFixed(2)}`,
        },
        grid: {
          color: "#e5e7eb",
          borderDash: [4, 4],
        },
      },
    },
  };
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "csv", label: "CSV" },
  ];
  const generateGraphData = (filter) => {
    const today = new Date();
    let datePoints = [];

    if (filter === "1M") {
      for (let i = 30; i >= 0; i -= 3) {
        datePoints.push(subDays(today, i));
      }
    } else if (filter === "3M") {
      for (let i = 90; i >= 0; i -= 7) {
        datePoints.push(subDays(today, i));
      }
    } else if (filter === "1Y") {
      for (let i = 12; i >= 0; i--) {
        datePoints.push(subMonths(today, i));
      }
    } else if (filter === "5Y") {
      for (let i = 5; i >= 0; i--) {
        datePoints.push(subYears(today, i));
      }
    }

    const formattedData = datePoints.map((date) => ({
      x: format(date, "yyyy-MM-dd"),
      y: Math.floor(Math.random() * 30) + 10,
    }));

    const formattedCaprockData = datePoints.map((date) => ({
      x: format(date, "yyyy-MM-dd"),
      y: Math.floor(Math.random() * 30) + 5,
    }));

    const formattedBenchmarkData = datePoints.map((date) => ({
      x: format(date, "yyyy-MM-dd"),
      y: 15, // static benchmark value or customize as needed
    }));
    let labelsLine =
      rawData.length > 0
        ? rawData.map((item) => {
            const date = new Date(item.date); // Parse the date
            return date; // Return Date object (Chart.js can parse Date objects)
          })
        : [];
    return {
      labels: labelsLine,
      datasets: [
        {
          label: "Your Strategy",
          data: stockpricesUsers,
          borderColor: "#DC4646",
          backgroundColor: "rgba(239, 68, 68, 0.1)",
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: "#DC4646",
          fill: true,
        },
        {
          label: "Caprock Strategy",
          data: stockPrices,
          borderColor: "#3047EC",
          backgroundColor: "rgba(59, 130, 246, 0.1)",
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: "#3047EC",
          fill: true,
        },
        {
          label: "Benchmark",
          data: combineIndex,
          borderColor: "#34C046",
          backgroundColor: "rgba(34, 197, 94, 0.05)",
          borderDash: [10, 10],
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 0,
          fill: false,
        },
      ],
    };
  };

  const dataLine = generateGraphData(selectedFilter);
  const [strategyData, setStrategyData] = useState([]);
  const [secondStrategyData, setSecondStrategyData] = useState([]);
  const location = useLocation();
  const [investmentAmount, setInvestmentAmount] = useState(0);

  const [isLoadingRebalacing, setIsLoadingRebalacing] = useState(false);
  const [loading, setLoading] = useState(false);
  const formatNumber = (value) => {
    if (!value) return "";
    // Remove non-numeric characters except dot
    const number = value.replace(/,/g, "");
    return Number(number).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const { from, strategyid, strategyName, showInvest } = location.state || {};
  const { showToast } = useToast();
  const [pdfData, setPdfData] = useState([]);
  const handleBlur = () => {
    if (investmentAmount) {
      setInvestmentAmount(Number(investmentAmount).toFixed(2)); // Ensure two decimal places are retained
    }
  };
  const handleInputChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setInvestmentAmount(rawValue); // Store raw value without commas

      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
    if (rawValue > 0) {
      setportfolioDataAvailable(false);
    }
  };
  const fetchStockApiBuySell = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/investment-hub/inspecie/details`;

    const bodyData = {
      user_id: userId,
      portfolio_id: strategyid,
      amount: investmentAmount,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getDetailsBuySell = useCallback(
    debounce(async () => {
      let toastMessage = null;

      try {
        const response = await fetchStockApiBuySell();
        if (response.status == 200) {
          setSecondStrategyData(response.data.categories);
          setportfolioDataAvailable(true);
        } else {
          toastMessage = { message: response.message, type: "error" };
          setStrategyData([]);
          setportfolioDataAvailable(false);
        }
      } catch (err) {
        setStrategyData([]);
        toastMessage = { message: err.message, type: "error" };
        setportfolioDataAvailable(false);
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investmentAmount, userId, strategyid] // Dependencies
  );
  const fetchStockApi = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/indepth-comparison`;

    const bodyData = {
      user_id: userId,
      portfolio_id: strategyid,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getDetails = async () => {
    try {
      const response = await fetchStockApi();
      if (response.status == 200) {
        setStrategyData(response.data.categories);
      } else {
        if (response.status === 400) {
          showToast(response.message, "error");
        }
        setStrategyData([]);
      }
    } catch (err) {
      setStrategyData([]);
      showToast(err.message, "error");
    } finally {
    }
  };
  const postFetchHistory = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/simulated-historic-performance`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let asxCodes = stockList.map((item) => item.stock_asx);
    let quantities = stockList.map((item) => item.quantity);
    const bodyData = {
      // portfolio_id: strategyid,
      portfolio_id: strategyid,
      time_interval: selectedFilter,
      stocks_asx: asxCodes,
      stocks_quantity: quantities,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const investNowApi = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/investment-hub/inspecie/request`;

    const bodyData = {
      user_id: userId,
      portfolio_id: strategyid,
      amount: investmentAmount,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const investNow = useCallback(
    debounce(async () => {
      let toastMessage = null;
      try {
        const response = await investNowApi();
        if (response.status == 200) {
          toastMessage = {
            message: "Investment request created successfully.",
            type: "success",
          };
          let redirectState = {
            path: "/my-investments",
            state: {
              from: location.pathname,
              historyStack: [
                ...(location.state?.historyStack || []),
                location.pathname,
              ],
            },
          };
          sessionStorage.setItem(
            "redirectAfterLogin",
            JSON.stringify(redirectState)
          );
          navigate(`/my-investments`);
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investmentAmount, userId, strategyid] // Dependencies
  );
  const fetchHistoryViewData = useCallback(
    debounce(async (e) => {
      setIsLoadingGraph(true);
      let toastMessage = null;
      try {
        const response = await postFetchHistory();
        if (response.status === 200) {
          setrawData(response.data.performance_data);
          const stockPrices = response.data.performance_data.map(
            (item) => item.value
          );
          const stockPricesUsers =
            response.data.user_stock_performance_data.map((item) => item.value);
          const combineIndices = response.data.combined_index_graph.map(
            (item) => item.value
          );
          setCombineIndex(combineIndices);
          setStockprices(stockPrices);
          setStockpricesUsers(stockPricesUsers);
          setCaprockStrategyChange(response.data.strategy_percentage_change);
          setUserStrategyChange(response.data.user_percentage_change);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        // Show toast after loading is false
        setIsLoadingGraph(false);
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [selectedFilter, stockList, userId, strategyid] // Dependencies
  );
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  function createTableBody(data, columns) {
    const body = document.createElement("tbody");

    data.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = columns
        .map(({ key, formatter }) => {
          let value = row[key];
          if (formatter) {
            value = formatter(value, row);
          }
          return `<td>${value !== undefined ? value : ""}</td>`;
        })
        .join("");

      body.appendChild(tr);
    });

    return body;
  }
  function generateStrategyTableHTML(strategyData) {
    return strategyData
      .map((category, categoryIdx) => {
        const headerBg =
          category.category.name.toUpperCase() === "GROWTH"
            ? "background: linear-gradient(to right, #93c5fd, #3b82f6); color: white;border-top-left-radius: 10px; border-top-right-radius: 10px;"
            : "background: linear-gradient(to right, #86efac, #22c55e); color: white;border-top-left-radius: 10px; border-top-right-radius: 10px;";

        const categoryHeader = `
        <div style="${headerBg} font-weight: bold; padding: 12px 16px; font-size: 14px;">
          ${category.category.name.toUpperCase()}
        </div>`;

        const productsHtml = category.category.products
          .map((product, productIdx) => {
            const rows = product.stocks
              .map((stock, stockIdx) => {
                return `
                <tr style="background-color: ${
                  stockIdx % 2 === 0 ? "#ffffff" : "#f9f9f9"
                };">
                  <td style="padding: 6px; font-size: 10px; color: #1f2937;">${
                    stock.name
                  }</td>
                  <td style="padding: 6px; font-size: 10px; color: #4b5563;">${
                    stock.asx_code
                  }</td>
                  <td style="padding: 6px; font-size: 10px;">${
                    stock.from_unallocated
                      ? stock.from_unallocated
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "00"
                  }</td>
                  <td style="padding: 6px; font-size: 10px;">
                    <span style="background: #d1fae5; color: #065f46; padding: 2px 6px; font-size: 10px; border-radius: 9999px;">
                      ${
                        stock.allocation ? stock.allocation.toFixed(2) : "00.00"
                      }
                    </span>
                  </td>
                  <td style="padding: 6px; font-size: 10px;">
                    <span style="background: #fef9c3; color: #92400e; padding: 2px 6px; font-size: 10px; border-radius: 9999px;">
                      ${
                        stock.required_quantity
                          ? stock.required_quantity
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "00.00"
                      }%
                    </span>
                  </td>
                  <td style="padding: 6px; font-size: 10px; font-weight: 600; color: #1d4ed8;">
                    ${
                      stock.to_buy
                        ? stock.to_buy
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "00"
                    }
                  </td>
                </tr>`;
              })
              .join("");

            return `
            <div style="background-color: #f3f4f6;">
              <div style="padding: 8px 16px; font-weight: 600; color: #005A9C; background-color: #f9fafb; border-bottom: 1px solid #d1d5db; font-size: 12px;">
                ${String(productIdx + 1).padStart(2, "0")}. ${product.name}
              </div>
              <div style="overflow-x: auto;">
                <table style="width: 100%; border-collapse: collapse; font-size: 10px;">
                  <thead>
                    <tr style="background-color: #e5e7eb; color: #374151;">
                      <th style="padding: 8px; text-align: left;">Stock Name</th>
                      <th style="padding: 8px; text-align: left;">ASX Code</th>
                      <th style="padding: 8px; text-align: left;">Available Quantity</th>
                      <th style="padding: 8px; text-align: left;">Current Allocation (%)</th>
                      <th style="padding: 8px; text-align: left;">Required Allocation (%)</th>
                      <th style="padding: 8px; text-align: left;">Buy Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${rows}
                  </tbody>
                </table>
              </div>
            </div>`;
          })
          .join("");

        return `
        <div style="border: 1px solid #e5e7eb; border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); margin-bottom: 24px;">
          ${categoryHeader}
          ${productsHtml}
        </div>`;
      })
      .join("");
  }

  const handleDownloadPDFTable = async () => {
    const date = new Date().toLocaleString();
    const strategyTableHTML = generateStrategyTableHTML(secondStrategyData);

    const fullHtml = `
          <!DOCTYPE html>
          <html>
            <head>
              <meta charset="utf-8" />
              <style>
              @page {
        size: A4 landscape;
        margin: 0;
      }
        html, body {
                margin: 0;
                padding: 0;
                          font-family:sans-serif;
        overflow: auto;  /* Ensure content can overflow */
      
                height: 100%; /* Ensure the body fills the entire height */
              }        .pdf-container {
                  max-width: 100% !important;
                  margin: 20px;
                }
                tr {
                  page-break-inside: avoid !important;
                  break-inside: avoid !important;
                }
        
                .custom-header {
                  position: relative;
                  display: flex;
                  justify-content: space-between;
                  background-color: #ffffff;
                  padding-top: 10px; /* Ensures no padding at the top */
               margin-bottom: 10px;
                  }
        
                .logo-container {
                  display: flex;
                  align-items: center;
                }
        
                .logo {
                  width: 96px; /* Tailwind w-24 = 6rem = 96px */
                  max-width: 150px;
                  height: auto;
                  object-fit: contain;
                  margin-right: 1rem;
                }
        
                .title {
                  position: absolute;
                  left: 50%;
                  transform: translateX(-50%);
                  font-size: 1.125rem; /* Tailwind text-lg */
                  font-weight: 500;    /* Tailwind font-medium */
                  padding: 0;          /* Remove any padding */
                  margin: 0;           /* Remove any margin */
                }
        
                .date {
                  font-size: 0.875rem;  /* Tailwind text-sm */
                  font-weight: 500;
                  color: #000000;
                  padding-bottom: 16px;
                }
      
        
      .page-break {
               page-break-before: always;
        break-before: page;
        display: block;
        height: 0; /* No extra space */
        width: 100%;
        content: "";}
            table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }
      
          thead {
            font-size: 10px;
            color: #6B7280; /* Tailwind text-labelColour equivalent */
          }
      
          th {
            border-bottom: 1px solid #000;
            padding: 8px;
            text-align: left;
          }
                td {
            padding: 6px;
            font-size: 10px;
            vertical-align: middle;
            text-align: left;
          }
            .tbody-tr{
                        background-color: #F9F9F9;
                        margin-bottom: 10px;
      
            }
              </style>
            </head>
            <body>
           <div class="pdf-container">
              <div class="custom-header">
                <div class="logo-container">
                  <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
                </div>
                <h2 class="title">Report - Caprock Model Portfolio - ${strategyName} </h2>
                <div class="date">${date}</div>
              </div>
              
         ${strategyTableHTML}

          
            </div> 
      
                 </body>
          </html>
        `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Report - Caprock Model Portfolio -${strategyName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTable(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (DownloadRef.current && !DownloadRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const postFetchSummary = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/comparison-summary`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      // portfolio_id: strategyid,
      portfolio_id: strategyid,
      user_id: userId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const fetchMatchViewData = useCallback(
    debounce(async (e) => {
      let toastMessage = null;
      try {
        const response = await postFetchSummary();
        if (response.status === 200) {
          setMatchedStocks(response.data.matched_stocks);
          setUnmatchedStocks(response.data.unmatched_stocks);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [userId, strategyid] // Dependencies
  );
  const GetUnallocatedList = async () => {
    const token = localStorage.getItem("jwtToken");
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/external-stocks/submissions/${userId}?status=APPROVED`;

    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAllUserUnallocatedAccounts = async () => {
    try {
      const response = await GetUnallocatedList();

      if (response.status == 200) {
        setStockList(response.data.submissions);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
          return;
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const downloadPDFTable = useCallback(
    debounce(async (e, option) => {
      // if (option.value == "csv") {
      //   try {
      //     const csvBlob = await GetCSV();
      //     const url = window.URL.createObjectURL(csvBlob);
      //     const a = document.createElement("a");
      //     a.href = url;
      //     a.download = `Investment Portfolios-${formattedDate}.csv`;
      //     document.body.appendChild(a);
      //     a.click();
      //     document.body.removeChild(a);
      //     window.URL.revokeObjectURL(url);
      //   } catch (err) {
      //     if (err.message.includes("401")) {
      //       localStorage.removeItem("jwtToken");
      //       navigate("/login");
      //     }
      //     if (err.message.includes("400")) {
      //       toast.error(
      //         <div className="flex items-center">
      //           <div className="mr-3">
      //             <img
      //               src="/tick-error.svg"
      //               alt="Success Icon"
      //               className="h-6 w-6"
      //             />
      //           </div>
      //           <div>
      //             <h3 className="font-semibold text-md text-black">Error!</h3>
      //             <p className="text-sm text-black">{err.message}</p>
      //           </div>
      //         </div>,
      //         {
      //           position: "top-right",
      //           autoClose: 5000,
      //           hideProgressBar: true,
      //           closeOnClick: true,
      //           pauseOnHover: true,
      //           draggable: true,
      //           icon: false,
      //           closeButton: (
      //             <button
      //               className="text-black "
      //               onClick={() => toast.dismiss()}
      //               style={{
      //                 backgroundColor: "transparent",
      //                 border: "none",
      //                 marginBottom: "2.813rem",
      //               }}
      //             >
      //               ✖
      //             </button>
      //           ),
      //           className: "error-toast text-md  rounded text-black",
      //         }
      //       );
      //     }
      //   } finally {
      //     setTimeout(function () {
      //       setLoading(false); // Ensure `loading` is false first
      //     }, 100);
      //   }
      // }
      if (option.value == "pdf") {
        try {
          if (secondStrategyData && secondStrategyData.length > 0) {
            setIsHiddenTable(true);
          } else {
            setIsHiddenTable(false);
            setLoading(false);
          }
        } catch (err) {
          setIsHiddenTable(false);
          setLoading(false);
          showToast(err.message, "error");
        }
      }
    }, 1000), // Debounce time
    [secondStrategyData] // Dependencies
  );
  useEffect(() => {
    if (isHiddenTable == true) {
      handleDownloadPDFTable();
    }
  }, [isHiddenTable]);
  useEffect(() => {
    getDetails();
    fetchMatchViewData();
    getAllUserUnallocatedAccounts();
  }, [strategyid]);
  useEffect(() => {
    if (stockList.length > 0) {
      fetchHistoryViewData();
    }
  }, [selectedFilter, strategyid, stockList]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="bg-white shadow-xl rounded-xl py-4 px-10 sm:px-10 mt-4 space-y-6 transition-all duration-300 ease-in-out">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
            <h2 className="text-lg font-medium text-black mb-1">
              Caprock Model Portfolio - {strategyName}
            </h2>
            <p className="text-sm text-gray-500">
              How your portfolio has performed vs. our optimized strategy
            </p>
          </div>
        </div>

        <div className=" bg-white">
          <div className="mb-4 flex flex-wrap justify-between items-center">
            <span>
              <h3 className="text-lg font-semibold text-black w-full md:w-auto">
                Performance Analysis
              </h3>
            </span>
          </div>

          <div className="mb-4 mt-4 flex w-full justify-between flex-wrap">
            <div className="pr-4 flex-wrap items-center">
              <div className="flex">
                {["5Y", "1Y", "3M", "1M"].map((filter, index) => (
                  <button
                    key={filter}
                    className={`px-3 py-1 shadow-md ${
                      filter === "1M" ? "rounded-r-xl" : ""
                    }
             ${filter === "5Y" ? "rounded-l-xl" : ""}
              
                ${
                  selectedFilter === filter
                    ? "bg-black text-white"
                    : "bg-white text-black"
                }`}
                    onClick={() => {
                      setSelectedFilter(filter);
                      if (filter === "1M") {
                        setPeriod("one month");
                      }
                      if (filter === "3M") {
                        setPeriod("three months");
                      }
                      if (filter === "1Y") {
                        setPeriod("one year");
                      }
                      if (filter === "5Y") {
                        setPeriod("five years");
                      }
                    }}
                  >
                    {filter}
                  </button>
                ))}
              </div>
            </div>
            {/* Flex container for image and performance text */}
            <div className="flex flex-col mt-4 md:mt-0   md:flex-row items-start ml-auto space-x-0 space-y-0">
              <div className="flex items-center pl-2 md:pl-0">
                <img src="/green-benchmark.svg" alt="taa" className="mr-1" />
                <span className="text-xs text-black">Benchmark</span>
              </div>
              <div className="flex items-center pl-2">
                <img src="/blue-taa.svg" alt="taa" className="mr-1" />
                <span className="text-xs text-black">Caprock Strategy</span>
              </div>
              <div className="flex items-center pl-2">
                <img src="/red-saa.svg" alt="income-orange" className="mr-1" />
                <span className="text-xs text-black">Your Strategy</span>
              </div>
            </div>
          </div>
          {isLoadingGraph ? (
            <div className="shimmer-container-list mb-4">
              {/* Creating 5 rows of shimmer effect */}
              {[...Array(2)].map((_, rowIndex) => (
                <div key={rowIndex} className="shimmer-row-list">
                  {/* Creating 7 cells in each row for shimmer */}
                  {[...Array(2)].map((_, colIndex) => (
                    <div key={colIndex} className="shimmer-cell-list h-20">
                      <div className="shimmer-loader"></div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <>
              <div style={{ width: "100%", height: "400px" }}>
                <Line data={dataLine} options={optionsLine} />
              </div>
              <div className="bg-white rounded-2xl shadow-sm px-4 text-gray-800">
                <h2 className="text-base sm:text-lg font-semibold mb-2 text-black">
                  Performance Overview
                </h2>
                <p className="text-sm  leading-relaxed">
                  Your portfolio achieved an average annual return of{" "}
                  <strong className="text-[#DC4646] font-medium">
                    {userStrategyChange
                      ? Number(userStrategyChange).toFixed(2)
                      : "0.00"}
                    %
                  </strong>{" "}
                  over the past {period}. By comparison, our strategic model
                  demonstrated a projected annual growth of{" "}
                  <strong className="text-[#3047EC] font-medium">
                    {caprockStrategyChange
                      ? Number(caprockStrategyChange).toFixed(2)
                      : "0.00"}
                    %
                  </strong>{" "}
                  during the same period.
                </p>
              </div>
            </>
          )}
        </div>
        {/* Summary */}
      </div>
      <div className="bg-white shadow-md rounded-xl p-4 mt-4">
        <div className="flex mt-4 justify-center items-center border-b mb-4">
          <h3 className="text-md font-semibold mb-2 ">In Depth Comparision</h3>
        </div>
        {strategyData && strategyData.length > 0 && (
          <div>
            <div className="overflow-x-auto mt-4">
              <table className="table-auto border-collapse w-full text-sm">
                <thead>
                  <tr className="bg-[#6AA7D3] text-white font-semibold">
                    <th className="border border-white  px-4 py-2">No</th>
                    <th className="border border-white  px-4 py-2">
                      Strategic Asset Allocation
                    </th>
                    <th className="border border-white  px-4 py-2">Code</th>
                    <th className="border border-white  px-4 py-2">Quantity</th>
                    <th className="px-4 py-2 border border-white ">
                      Matched %
                    </th>
                  </tr>
                </thead>
                {isLoadingRebalacing ? (
                  <tbody className="shimmer-container-list ">
                    {/* Creating 5 rows of shimmer effect */}
                    {[...Array(5)].map((_, rowIndex) => (
                      <tr key={rowIndex} className="shimmer-row-list">
                        {/* Creating 7 cells in each row for shimmer */}
                        {[...Array(5)].map((_, colIndex) => (
                          <td key={colIndex} className="shimmer-cell-list">
                            <div className="shimmer-loader"></div>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    {strategyData.map((categoryData, categoryIndex) => (
                      <React.Fragment key={categoryIndex}>
                        {/* Category Row */}
                        <tr
                          className={`px-6 py-2 rounded-lg ${
                            categoryData.name.toUpperCase() == "GROWTH"
                              ? "bg-[#92C5EA]"
                              : "bg-[#A9D4AB]"
                          }`}
                        >
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold"
                          ></td>
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold"
                          >
                            {categoryData.name.toUpperCase()}
                          </td>
                          <td
                            colSpan={1}
                            className="border border-white  px-4 py-2 font-bold"
                          ></td>
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold"
                          ></td>
                          <td
                            colSpan={1}
                            className="border border-white px-4 py-2 font-bold "
                          ></td>
                        </tr>

                        {/* Products */}
                        {categoryData.products.map((product, productIndex) => (
                          <React.Fragment key={productIndex}>
                            {/* Product Row */}
                            <tr
                              className={`text-[#005A9C] ${
                                categoryData.name.toUpperCase() == "GROWTH"
                                  ? "bg-[#C6DFF1]"
                                  : "bg-[#C0E2C1]"
                              }`}
                            >
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              >
                                {(productIndex + 1).toString().padStart(2, "0")}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-semibold"
                              >
                                {product.name}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-semibold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                            </tr>

                            {/* Stocks */}
                            {product.stocks.map((stock, stockIndex) => (
                              <tr
                                key={stockIndex}
                                className={`text-[#black] ${
                                  categoryData.name.toUpperCase() == "GROWTH"
                                    ? "bg-[#E6F3FC]"
                                    : "bg-[#E7F5E8]"
                                }`}
                              >
                                <td className="border border-white px-4 py-2"></td>
                                <td className="border border-white px-4 py-2">
                                  {stock.name}
                                </td>
                                <td className="text-center border border-white px-4 py-2">
                                  {stock.asx_code}
                                </td>
                                <td className="text-center border border-white px-4 py-2">
                                  {!stock.user_quantity
                                    ? "00"
                                    : stock.user_quantity
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                </td>
                                {/* <td className="text-center font-bold border border-white px-4 py-2 text-[#00695C]">
                                  {stock.strategy_percentage.toFixed(2)}
                                </td> */}
                                <td
                                  colSpan={1}
                                  className="border border-white px-4 py-2 font-bold flex justify-center items-center"
                                >
                                  <button
                                    disabled={true}
                                    className={`font-medium h-4 rounded-xl px-4 py-2 flex justify-between items-center focus:outline-none
                border-2 border-[#34C046] text-[#34C046] bg-white`}
                                  >
                                    <span>
                                      {!stock.strategy_percentage
                                        ? "00"
                                        : stock.strategy_percentage.toFixed(2)}
                                    </span>
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                        {/* Sub total row for each category */}
                        {/* <tr
                          className={`font-bold ${
                            categoryData.name.toUpperCase() == "GROWTH"
                              ? "bg-[#92C5EA]"
                              : "bg-[#A9D4AB]"
                          }`}
                        >
                          <td colSpan={1} className="border px-4 py-2"></td>
                          <td colSpan={2} className="border px-4 py-2">
                            SUB-TOTAL {categoryData.name}
                          </td>
                          <td colSpan={1} className="border px-4 py-2"></td>
                          <td colSpan={1} className="border px-4 py-2">
                            {categoryData.current_percentage.toFixed(2)}
                          </td>
                        </tr> */}
                      </React.Fragment>
                    ))}
                    <React.Fragment>
                      {/* Summary section */}
                      {/* <tr className="bg-[#EAEAEA] font-bold">
                        <td
                          colSpan={1}
                          className="border px-4 py-2 text-right"
                        ></td>
                        <td colSpan={2} className="border px-4 py-2">
                          Summary
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                      </tr>
                      <tr className="bg-[#92C5EA]  font-bold">
                        <td
                          colSpan={1}
                          className="border px-4 py-2 text-right"
                        ></td>
                        <td colSpan={2} className="border px-4 py-2">
                          {strategyData[0].name}
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={1} className="border px-4 py-2">
                                                 {strategyData[0].current_percentage.toFixed(2)}

                        </td>
                      </tr>
                      <tr className="bg-[#A9D4AB]  font-bold">
                        <td
                          colSpan={1}
                          className="border px-4 py-2 text-right"
                        ></td>
                        <td colSpan={2} className="border px-4 py-2">
                          {strategyData[1].name}
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={1} className="border px-4 py-2">
                                                   {strategyData[1].current_percentage.toFixed(2)}

                        </td>
                      </tr>
                      <tr className="bg-[#CDCDCD] font-bold">
                        <td colSpan={1} className="border px-4 py-2"></td>
                        <td colSpan={2} className="border px-4 py-2">
                          TOTAL PORTFOLIO
                        </td>
                        <td colSpan={1} className="border px-4 py-2"></td>

                        <td colSpan={1} className="border px-4 py-2">
                          {(
                            strategyData[0].current_percentage +
                            strategyData[1].current_percentage
                          ).toFixed(2) || "-"}
                        </td>
                      </tr> */}
                    </React.Fragment>
                  </tbody>
                )}
              </table>
            </div>
          </div>
        )}
      </div>
      <div className="mt-4 mb-2">
        <StockMatchSummary
          matchedStocks={matchedStocks}
          unmatchedStocks={unmatchedStocks}
        />
      </div>
      <div className="bg-white shadow-md rounded-xl p-4 mt-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0 mb-4">
          {/* Left Section: Input Field and Button */}
          <div className="flex flex-col w-full md:w-1/3 lg:w-1/4">
            {/* Label */}
            <label
              htmlFor="investmentAmount"
              className="text-sm font-medium text-labelColour mb-2 pr-4"
            >
              Enter amount
            </label>
            {/* Input and Button Section */}
            <div className="flex items-center space-x-2">
              {/* Input Field */}
              <div className="relative flex-grow">
                {/* Dollar Icon */}
                <span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
                  $
                </span>
                <input
                  id="investmentAmount"
                  ref={inputRef}
                  type="text"
                  value={formatNumber(investmentAmount)}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  className="pl-6 pr-3 py-2 border border-gray-300 rounded-md text-right w-full md:w-40"
                />
              </div>

              {/* View Breakdown Button */}
              <button
                disabled={portfolioDataAvailable ? true : false}
                onClick={(e) => {
                  e.preventDefault();
                  if (investmentAmount == 0) {
                    showToast("Please enter the valid amount", "error");
                    return;
                  }
                  setLoading(true);
                  getDetailsBuySell(e);
                }}
                className={`${
                  portfolioDataAvailable
                    ? "bg-gray-400  text-black"
                    : "bg-black cursor-pointer  text-white"
                } px-4 py-2 text-sm rounded-full whitespace-nowrap`}
              >
                View Report
              </button>
            </div>
          </div>

          {/* Right Section: Download Report */}
          <div className="flex items-center justify-end w-60 md:w-1/3 lg:w-1/4">
            {secondStrategyData &&
              secondStrategyData.length > 0 &&
              portfolioDataAvailable && (
                <div ref={DownloadRef} className="relative mt-6">
                  {/* Dropdown Button */}
                  <div
                    className="flex justify-between w-60 items-center px-3 py-2 border border-gray-300 rounded-md cursor-pointer"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    <img
                      src="/document-download.svg"
                      alt="Download Icon"
                      className="w-4 h-4 mr-2"
                    />
                    <span className="flex-grow truncate">
                      {selectedInvestorReport}
                    </span>
                    <img
                      src="/download-small-arrow.svg"
                      alt="Chevron Down"
                      className="w-3 h-3 text-gray-500"
                    />
                  </div>

                  {isOpen && (
                    <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                      {options.map((option) => (
                        <li
                          key={option.value}
                          className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            setLoading(true);
                            downloadPDFTable(e, option);
                          }}
                        >
                          {option.label}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
          </div>
        </div>
        {secondStrategyData &&
          secondStrategyData.length > 0 &&
          portfolioDataAvailable && (
            <div className="space-y-6 mt-4">
              {secondStrategyData.map((category, categoryIdx) => (
                <div
                  key={categoryIdx}
                  className="rounded-xl shadow-lg overflow-hidden border border-gray-200"
                >
                  <div
                    className={`text-md font-bold px-4 py-3 ${
                      category.category.name.toUpperCase() === "GROWTH"
                        ? "bg-gradient-to-r from-blue-300 to-blue-500 text-white"
                        : "bg-gradient-to-r from-green-300 to-green-500 text-white"
                    }`}
                  >
                    {category.category.name.toUpperCase()}
                  </div>

                  <div className="divide-y divide-gray-200">
                    {category.category.products.map((product, productIdx) => (
                      <div key={productIdx} className="bg-white">
                        <div className="px-4 py-2 font-semibold text-[#005A9C] bg-gray-100 border-b border-gray-300 text-sm sm:text-base">
                          {String(productIdx + 1).padStart(2, "0")}.{" "}
                          {product.name}
                        </div>

                        {/* Table Wrapper for Horizontal Scroll */}
                        <div className="overflow-x-auto">
                          <table className="min-w-[768px] w-full text-sm text-left">
                            <thead>
                              <tr className="bg-gray-200 text-gray-700">
                                <th className="px-4 py-3">Stock Name</th>
                                <th className="px-4 py-3">ASX Code</th>
                                <th className="px-4 py-3">
                                  Available Quantity
                                </th>
                                <th className="px-4 py-3">
                                  Current Allocation (%)
                                </th>
                                <th className="px-4 py-3">Required Quantity</th>
                                <th className="px-4 py-3">Buy Quantity</th>
                              </tr>
                            </thead>
                            <tbody>
                              {product.stocks.map((stock, stockIdx) => (
                                <tr
                                  key={stockIdx}
                                  className="even:bg-gray-50 hover:bg-blue-50 transition"
                                >
                                  <td className="px-4 py-2 w-48 min-w-0 whitespace-normal break-words text-gray-800">
                                    {stock.name}
                                  </td>
                                  <td className="px-4 py-2 text-gray-600">
                                    {stock.asx_code}
                                  </td>
                                  <td className="px-4 py-2 text-gray-800">
                                    {stock.from_unallocated
                                      ? stock.from_unallocated
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "00"}
                                  </td>
                                  <td className="px-4 py-2">
                                    <span className="inline-block bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded-full">
                                      {stock.allocation
                                        ? stock.allocation.toFixed(2)
                                        : "00.00"}
                                    </span>
                                  </td>
                                  <td className="px-4 py-2">
                                    <span className="inline-block bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-1 rounded-full">
                                      {stock.required_quantity
                                        ? stock.required_quantity
                                            .toString()
                                            .replace(
                                              /\B(?=(\d{3})+(?!\d))/g,
                                              ","
                                            )
                                        : "00.00"}{" "}
                                    </span>
                                  </td>
                                  <td className="px-4 py-2 text-blue-700 font-semibold">
                                    {stock.to_buy
                                      ? stock.to_buy
                                          .toString()
                                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                      : "00"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>

      {showInvest && (
        <>
          <div className="bg-white shadow-xl rounded-xl py-4 px-10 sm:px-10 mt-4 space-y-6 transition-all duration-300 ease-in-out">
            {/* CTA Onboarding Section */}
            <div className="mt-6 bg-gradient-to-r from-blue-50 to-green-50 rounded-xl p-6 shadow-lg border border-blue-100">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div>
                  <h3 className="text-md sm:text-xl font-semibold text-black mb-1">
                    Ready to Invest in This Strategy?
                  </h3>
                  <p className="text-sm text-gray-600 max-w-lg">
                    You’ve reviewed the performance and potential. If it fits
                    your vision, act now and make this strategy a part of your
                    investment journey.
                  </p>
                </div>
                <div className="relative group inline-block">
                  <button
                    disabled={investmentAmount == 0}
                    onClick={(e) => {
                      e.preventDefault();
                      if (investmentAmount == 0) {
                        showToast("Please enter the valid amount", "error");
                        return;
                      }
                      setLoading(true);
                      investNow(e);
                    }}
                    className={` ${
                      investmentAmount == 0
                        ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                        : "bg-black text-white hover:bg-gray-900 hover:scale-105 active:scale-95"
                    } text-sm mt-3 sm:mt-0 px-6 py-2 rounded-full font-semibold transition duration-200`}
                  >
                    Invest Now
                  </button>

                  {/* Tooltip when disabled */}
                  {investmentAmount == 0 && (
                    <span className="absolute left-1/2 -translate-x-1/2 -top-10 scale-0 group-hover:scale-100 transition-transform duration-200 bg-black text-white text-xs px-3 py-1 rounded-md whitespace-nowrap">
                      Please enter amount first
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default StrategyDetails;
